import request from './request';

export async function list(page: number, perPage: number, email?: string) {
  return request('GET', '/api/users', { page, perPage, email });
}

export async function create(email?: string, password?: string) {
  return request('POST', '/api/users', { email, password });
}

export async function update(id: string, email?: string, password?: string) {
  return request('POST', `/api/users/${id}`, { email, password });
}

export async function remove(id: string) {
  return request('DELETE', `/api/users/${id}`);
}
